import { render, staticRenderFns } from "./addtestpop.vue?vue&type=template&id=787e7fab"
import script from "./addtestpop.vue?vue&type=script&lang=js"
export * from "./addtestpop.vue?vue&type=script&lang=js"
import style0 from "./addtestpop.vue?vue&type=style&index=0&id=787e7fab&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports